var map = {
	"./additionalInfoIcon.svg": 593,
	"./arrowLeftIcon.svg": 594,
	"./arrowMediumTop.svg": 595,
	"./arrowRightIcon.svg": 596,
	"./arrowRightIconSharp.svg": 597,
	"./arrowRightSmallIcon.svg": 598,
	"./arrowScalableIcon.svg": 599,
	"./arrowSelect2.svg": 600,
	"./arrowSelectIcon.svg": 601,
	"./benefit1.svg": 602,
	"./benefit2.svg": 603,
	"./benefit3.svg": 604,
	"./cardsIcon.svg": 605,
	"./circleInfoIcon.svg": 606,
	"./copyIcon copy.svg": 607,
	"./copyIcon.svg": 608,
	"./crossIcon.svg": 609,
	"./crossIcon2.svg": 610,
	"./crossIcon3.svg": 611,
	"./crossIconSmall.svg": 612,
	"./crossSmallIcon.svg": 613,
	"./defaultCategoryIcon.svg": 614,
	"./depNumberIcon.svg": 615,
	"./elfCentralIcon.svg": 616,
	"./equalitySign.svg": 617,
	"./errorIcon.svg": 618,
	"./eyeClosedIcon.svg": 619,
	"./eyeOpenIcon.svg": 620,
	"./favoritesIcon.svg": 621,
	"./favoritesLabelIcon.svg": 622,
	"./filterDivider.svg": 623,
	"./filterIcon.svg": 624,
	"./frequencyIcon.svg": 625,
	"./fsAmountIcon.svg": 626,
	"./fullScreenIcon.svg": 627,
	"./gameIcon.svg": 628,
	"./hamburgerIcon.svg": 629,
	"./infoIcon.svg": 630,
	"./infoSymbol.svg": 631,
	"./levelBackground.svg": 632,
	"./levelBackgroundNew.svg": 633,
	"./linkIcon.svg": 634,
	"./lockIcon.svg": 635,
	"./lockSharpIcon.svg": 636,
	"./maxBonusAmountIcon.svg": 637,
	"./maxWinFsIcon.svg": 638,
	"./menu/fortuneIcon.svg": 362,
	"./menu/fortuneIconL.svg": 363,
	"./menu/helpdeskIcon.svg": 364,
	"./menu/helpdeskIconL.svg": 365,
	"./menu/homeIcon.svg": 366,
	"./menu/homeIconLarge.svg": 367,
	"./menu/jackpotIcon.svg": 368,
	"./menu/logo.svg": 369,
	"./menu/logoSmall.svg": 370,
	"./menu/loyaltyIcon.svg": 371,
	"./menu/mobileAppIcon.svg": 372,
	"./menu/profileIcon.svg": 373,
	"./menu/questIcon.svg": 374,
	"./menu/rewardLineupIcon.svg": 375,
	"./menu/searchIcon.svg": 376,
	"./menu/searchIconLarge.svg": 377,
	"./menu/signOutIcon.svg": 378,
	"./menu/star.svg": 379,
	"./menu/tournamentIcon.svg": 380,
	"./menu/tournamentLargeIcon.svg": 381,
	"./menu/vipIcon.svg": 382,
	"./menu/wheelIcon.svg": 383,
	"./menu/wheelIconL.svg": 384,
	"./menu/wheelIconMobile.svg": 385,
	"./menuIcon.svg": 639,
	"./minDepIcon.svg": 640,
	"./noTournamentIcon.svg": 641,
	"./numbers/number-1.svg": 386,
	"./numbers/number-2.svg": 387,
	"./numbers/number-3.svg": 388,
	"./numbers/number-4.svg": 389,
	"./numbers/number-5.svg": 390,
	"./numbers/number-6.svg": 391,
	"./numbers/number-7.svg": 392,
	"./numbers/number-8.svg": 393,
	"./numbers/number-9.svg": 394,
	"./numbers/number-shine-1.svg": 395,
	"./numbers/number-shine-2.svg": 396,
	"./numbers/number-shine-3.svg": 397,
	"./numbers/number-shine-4.svg": 398,
	"./numbers/number-shine-5.svg": 399,
	"./numbers/number-shine-6.svg": 400,
	"./numbers/number-shine-7.svg": 401,
	"./numbers/number-shine-8.svg": 402,
	"./numbers/number-shine-9.svg": 403,
	"./playIcon.svg": 642,
	"./polygon.svg": 643,
	"./preloaderDotsAnimation.svg": 644,
	"./preloaderSpinnerAnimation.svg": 645,
	"./presentIcon.svg": 646,
	"./promoIcon.svg": 647,
	"./recentIcon.svg": 648,
	"./search2Icon.svg": 649,
	"./search3Icon.svg": 650,
	"./sharpTickIcon copy.svg": 651,
	"./sharpTickIcon.svg": 652,
	"./smallInfoSymbol.svg": 653,
	"./smoothArrowIcon.svg": 654,
	"./successIcon.svg": 655,
	"./supportIcon.svg": 656,
	"./tag1Icon.svg": 657,
	"./tag2Icon.svg": 658,
	"./tag3Icon.svg": 659,
	"./tag4Icon.svg": 660,
	"./tickIcon.svg": 661,
	"./unverified.svg": 662,
	"./verified.svg": 663,
	"./wagerIcon.svg": 664,
	"./wagerTimeIcon.svg": 665,
	"./warningIcon.svg": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;